export default __webpack_public_path__ + "static/media/NITROBANNER.7b17ce0b.JPG";